import React from 'react';

const LineChart2SVG = ({ color, className, onClick, ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='491'
      height='141'
      viewBox='0 0 491 141'
      fill='none'
      onClick={onClick}
      className={className}
      {...props}
    >
      <path
        d='M48.422 59.0777C36.1898 67.4777 19.8803 60.2444 13.2545 55.5777L-26.5 190.078L497.189 205.078C500.502 143.911 502.847 19.2777 485.722 10.0777C464.315 -1.4223 453.612 20.0777 449.79 26.5777C445.967 33.0777 432.971 38.0777 422.267 36.0777C411.564 34.0777 388.629 59.0777 372.574 65.0777C356.52 71.0777 334.349 38.0777 324.41 32.5777C314.471 27.0778 306.062 39.0777 302.239 38.0777C298.417 37.0777 282.362 5.5777 270.894 6.0777C259.427 6.5777 249.488 36.0777 241.079 32.5777C232.669 29.0778 223.495 55.5777 195.208 73.0777C166.921 90.5777 155.453 6.57772 140.163 2.57772C124.873 -1.42228 120.286 16.0777 104.996 32.5777C89.7055 49.0777 82.8249 36.5777 78.2379 32.5777C73.6508 28.5777 63.7122 48.5777 48.422 59.0777Z'
        fill='url(#paint0_linear_12161_667147)'
        stroke='#4318FF'
        strokeWidth='4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <defs>
        <linearGradient
          id='paint0_linear_12161_667147'
          x1='237.256'
          y1='-17.5'
          x2='237.256'
          y2='164.578'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#E9E3FF' />
          <stop offset='0.72165' stopColor='#E9E3FF' stopOpacity='0' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default LineChart2SVG;
